"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var mode_1 = require("./../const/mode");

exports.defaultSettings = {
  defaultBackgroundColor: {
    r: 245,
    g: 0,
    b: 87,
    a: 1
  },
  defaultGradientColor: {
    r: 245,
    g: 0,
    b: 87,
    a: 1
  },
  defaultGradientSecondaryColor: {
    r: 71,
    g: 245,
    b: 87,
    a: 1
  },
  defaultMode: 1,
  defaultModeFlag: 1,
  defaultDarken: 0.1,
  defaultLighten: 0,
  defaultHasPadding: true,
  defaultIsParallax: true,
  enabledModes: mode_1.IMAGE_MODE_FLAG | mode_1.COLOR_MODE_FLAG | mode_1.GRADIENT_MODE_FLAG,
  Controls: function Controls() {
    return React.createElement(React.Fragment, null, " Controls for this plugin were not provided");
  },
  Renderer: function Renderer() {
    return React.createElement(React.Fragment, null, "Renderer; for this plugin was not provided ");
  }
};